<ui-card [loading]="isLoading">
    <app-segment-header class="flex" title="{{ 'applicant-tracker.applicants.applicationInformation' | appTranslate }}">
    </app-segment-header>
    <div class="vertical-labels" *ngIf="applicationInformation">
        <div class="vertical-label">
            <div>{{ 'applicant-tracker.applicants.applicationDate' | appTranslate }}</div>
            <div data-testid="application-date">{{ applicationInformation?.createdAt | appDate: 'longDate' }}</div>
        </div>

        <div class="vertical-label">
            <div>{{ 'applicant-tracker.applicants.applicationSource' | appTranslate }}</div>
            <div>
                <span
                    class="application-source"
                    *ngIf="
                        applicationInformation.source && applicationInformation.source !== 'Unknown';
                        else unknownOrFailedToSync
                    "
                    >{{ applicationInformation.source }}</span
                >

                <ng-template #unknownOrFailedToSync>
                    <span
                        class="application-source"
                        *ngIf="
                            applicationInformation.source === undefined || applicationInformation.source === null;
                            else unknown
                        "
                        >{{ 'applicant-tracker.applicants.failedToSync' | appTranslate }}</span
                    >
                </ng-template>

                <ng-template #unknown>
                    <span class="application-source"
                        >{{ 'applicant-tracker.applicants.unknown' | appTranslate
                        }}<ui-info
                            [matTooltipClass]="'allow-multi-line-tooltip'"
                            [text]="'applicant-tracker.tips.youMightFindSomeSourcesAsUnknown'"
                        ></ui-info>
                    </span>
                </ng-template>
            </div>
        </div>
    </div>
</ui-card>
